import * as t from 'io-ts';

export const ContactDynamicType = t.interface({
    telephone: t.union([t.string, t.null]),
    name: t.union([t.string, t.null])
});

export type Contact = t.TypeOf<typeof ContactDynamicType>;
